import ProfilePhotoDialogForm from './ProfilePhotoDialogForm';

export default ProfilePhotoDialogForm;
